import { Reveal } from "@/components/Reveal";
import { CTA, Eyebrow } from "@/components/ui-kit";
import { IMAGES } from "@/lib/content";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative bg-black noise pt-40 pb-20 lg:pt-48 lg:pb-28">
        <div className="relative z-10 max-w-[1240px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <div className="relative max-w-md">
              <div className="absolute -inset-4 border border-[#D4AF37]/40" aria-hidden="true" />
              <img src={IMAGES.portrait} alt="Don Orr Jr." className="relative w-full bg-black mask-fade" />
            </div>
          </Reveal>
          <Reveal delay={120}>
            <Eyebrow>About the Author</Eyebrow>
            <h1 className="font-display text-5xl lg:text-6xl text-white mt-7 tracking-tight leading-[1.03]">
              Don Orr Jr.
            </h1>
            <div className="w-14 h-px bg-[#D4AF37] my-8" />
            <div className="space-y-6 font-body text-lg text-white/65 leading-relaxed">
              <p className="text-white text-xl">
                I spent years believing there had to be more. Not just more money — more meaning.
              </p>
              <p>
                Like a lot of people, I was working hard and still felt like I was only surviving.
                Somewhere along the way I realized the problem wasn’t effort. It was foundation.
              </p>
              <p>
                We’re taught to chase results and manage circumstances. Almost no one teaches us
                how to build a life on purpose — one rooted in character, service, and stewardship.
              </p>
              <p className="font-display italic text-[#D4AF37] text-xl">
                So I decided to become a Builder. Then I wrote the book I wish someone had handed me.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* MISSION */}
      <section className="bg-white text-black py-28 lg:py-36">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Eyebrow className="!text-[#B8952E]">The Mission</Eyebrow>
          <Reveal delay={100}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-8 leading-tight tracking-tight">
              Help people stop surviving — and start building lives of purpose, integrity,
              service, leadership, and lasting impact.
            </h2>
          </Reveal>
          <Reveal delay={220}>
            <p className="font-body text-lg text-black/55 mt-10 leading-relaxed">
              This is not about getting rich. It’s not about quitting your job. It’s about
              becoming the person you were created to become — and building something that
              outlives you.
            </p>
          </Reveal>
          <Reveal delay={300}>
            <div className="mt-11 flex justify-center">
              <CTA to="/philosophy" variant="ghost-dark">Explore the Philosophy</CTA>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
